import { Organisation } from "graphql/generated/types";
import { storeItem, useRecentStack } from "./useRecentStack";

export type RecentOrganisation = Pick<Organisation, "name" | "logo" | "shortName">;
const LOCAL_STORAGE_KEY = "recentOrganisations";

export const useRecentOrganisations = () =>
    useRecentStack<RecentOrganisation>(LOCAL_STORAGE_KEY)[0];

export const saveRecentOrganisation = (organisation: RecentOrganisation) => {
    storeItem(LOCAL_STORAGE_KEY, organisation, keyFn);
};

const keyFn = (organisation: RecentOrganisation) => organisation.shortName;
